import { isNil } from 'lodash/fp'
import { fetchUtils } from 'react-admin'

const env = process.env['ENV'] as string
export const url = !isNil(process.env['API_LOCAL'])
  ? 'http://localhost:14001/v1'
  : {
      prd: 'https://api.bapp.terashite.jp/v1',
      stg: 'https://api-stg.bapp.terashite.jp/v1',
      int: 'https://api-int.bapp.dev.terashite.jp/v1',
      dev: 'https://api-dev.bapp.terashite.jp/v1',
      exp: 'https://api-exp.bapp.dev.terashite.jp/v1'
    }[env]

export const getCustomHeaders = (
  options: fetchUtils.Options = {},
  accessKey: string
): Headers | undefined => {
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  customHeaders.set('x-accessKey', accessKey)
  return customHeaders
}
export const fetchJson =
  (accessKey: string) =>
  (url: string, options: fetchUtils.Options = {}): any => {
    const customHeaders = getCustomHeaders(options, accessKey)
    if (isNil(customHeaders)) return undefined
    options.headers = customHeaders
    return fetchUtils.fetchJson(url, options)
  }
export const getSolarDataLists = async (
  partner: string,
  hash: string,
  accessKey: string
): Promise<Array<{ name: string; key: string }> | undefined> => {
  const { status, json } = await fetchJson(accessKey)(
    `${url as string}/solarData/${partner}/${hash}`,
    {
      method: 'GET'
    }
  )
  return status !== 200 ? undefined : json
}
export const getSolarData = async (
  partner: string,
  hash: string,
  name: string,
  key: string,
  accessKey: string
): Promise<{ name: string; data: Buffer } | undefined> => {
  const {
    status,
    json: { data }
  } = await fetchJson(accessKey)(
    `${url as string}/solarData/${partner}/${hash}`,
    {
      method: 'POST',
      body: JSON.stringify({ key })
    }
  )
  return status !== 200
    ? undefined
    : { name, data: Buffer.from(data, 'base64') }
}
